import { Component, Input, OnInit } from '@angular/core'
import { CommonModule } from '@angular/common'
import { AssistanceStatus } from '../../../models/assistanceStatus'

@Component({
  selector: 'app-assistance-status',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './assistance-status.component.html',
  styleUrls: ['./assistance-status.component.scss'],
})
export class AssistanceStatusComponent implements OnInit {
  @Input() status: AssistanceStatus

  constructor() {}

  ngOnInit() {}
}
